"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toolBase = require("@futuweb/tool-base");
var _toolBrowser = _interopRequireWildcard(require("@futuweb/tool-browser"));
var browser = _toolBrowser;
var _toolXhr = require("@futuweb/tool-xhr2");
var _nnq = _interopRequireDefault(require("./nnq"));
var _schema = _interopRequireDefault(require("./schema"));
var Utils = _interopRequireWildcard(require("./utils"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * Created by rick on 2016/3/2.
 */

// 协议文档：http://gitlab.futunn.com/echo/doc_sc/blob/master/nn_proto/%E7%89%9B%E7%89%9BURL_Scheme%E6%A0%BC%E5%BC%8F%E5%AE%9A%E4%B9%89.md
// http://gitlab.futunn.com/echo/doc_sc/blob/master/web_http_api/niuniunotice.md

var filterChannel = Utils.filterChannel;
var filterSnapshotChannel = Utils.filterSnapshotChannel;

// 相关文档http://fservice.server.com/repository/project/1190057/proto-space/4691/main/-/setShareConfig.md?method_branch=main
// 渠道大小写的映射关系
var channelMap = {
  niuyou: 'NiuYou',
  chatRoom: 'ChatRoom',
  nnq: 'Circle',
  wxFriend: 'Wechat',
  wxTimeline: 'WechatMoments',
  qq: 'QQ',
  weibo: 'SinaWeibo',
  facebook: 'Facebook',
  twitter: 'Twitter',
  whatsapp: 'Whatsapp',
  dingtalk: 'dingtalk',
  line: 'line',
  telegram: 'telegram',
  xiaohongshu: 'xiaohongshu',
  reddit: 'reddit'
};

// 客服咨询NN号
var customerService = '10002';
var _default = exports["default"] = {
  /**
   * [getProtocol 根据futunn的相关协议，获取futunn或者moomoo的协议]
   * @return {String} [对应牛牛的协议]
   */
  getProtocol: function getProtocol(str) {
    var isMoomoo = browser.isMoomoo();
    if (/^(futunn)|(futumm)$/gi.test(str)) {
      return isMoomoo ? 'futumm' : 'futunn';
    } else if (/^(ftnn)|(ftmm)$/gi.test(str)) {
      return isMoomoo ? 'ftmm' : 'ftnn';
    } else if (/^(niuniunotice)|(moomoonotice)$/gi.test(str)) {
      return isMoomoo ? 'moomoonotice' : 'niuniunotice';
    } else {
      return str;
    }
  },
  /**
   * 配置牛牛的分享项（影响右上角菜单）或显示title
   * @param {Object} options - 配置项
   * {
   *  link : 分享出去的url
   *  title : 标题
   *  desc : 描述
   *  imgUrl : 分享图片地址
   *  disabled : 屏蔽哪些分享途径，可传数组，包括niuyou，chatRoom，nnq，wxFriend，wxTimeline，qq，weibo，facebook，twitter传字符串all时会屏蔽右上角分享按钮
   *  showTitle : 显示在顶部的title,
   *  linkType : 上报类型 1-个股资讯 2-新闻资讯
   * }
   */
  config: function config(options) {
    if (!browser.isMobileNN()) {
      return;
    }
    var schema = [this.getProtocol('niuniunotice') + '://url_change?url=', encodeURIComponent(options.link || window.location.href), '&title=', encodeURIComponent(options.title || window.document.title), '&description=', encodeURIComponent(options.desc || ''), '&imageUrl=', encodeURIComponent(options.imgUrl || 'https://www.futunn.com/images/mobile/nn01.png'), '&disabled=', filterChannel(options.disabled), '&showTitle=', encodeURIComponent(options.showTitle || window.document.title), '&linkType=', encodeURIComponent(options.linkType || '')];

    // 支持设置成功回调
    if (this.isSupportShareCallback() && (options.success || options.fail)) {
      schema = schema.concat(['&callback=', this._getRandomFn(options.success, options.fail)]);
    }
    _schema["default"].loadSchema(schema.join(''));
  },
  /**
  * 配置牛牛的分享项（影响右上角菜单）或显示title
  * 证券业务webview通用分享配置方法，主要用于防止证券业务的马甲域名外露；
  * 默认要禁用系统分享
  * @param {Object} options - 配置项
  * {
  *  link : 分享出去的url
  *  linkMap: url转换规则，map格式；比如{'support5.futunn.com': 'support.futuhk.com'}会将support5.futunn.com替换成support.futuhk.com
  *  title : 标题
  *  desc : 描述
  *  imgUrl : 分享图片地址
  *  disabled : 屏蔽哪些分享途径，可传数组，包括niuyou，chatRoom，nnq，wxFriend，wxTimeline，qq，weibo，facebook，twitter传字符串all时会屏蔽右上角分享按钮
  *  showTitle : 显示在顶部的title,
  *  linkType : 上报类型 1-个股资讯 2-新闻资讯
  * }
  */
  configSafety: function configSafety(options) {
    var deepCloneData = (0, _toolBase.extend)({}, options || {}, true);

    // 默认禁用系统分享
    var _configs = Object.assign({
      disabled: ['system']
    }, deepCloneData);

    // 根据linkMap规则，转换url
    if (_configs.linkMap) {
      Object.entries(_configs.linkMap).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
          key = _ref2[0],
          val = _ref2[1];
        _configs.link = _configs.link.replace(key, val);
      });
    }
    this.configV2(_configs);
  },
  /**
   * 直接触发牛牛弹出分享框。
   * @param {Object} options - 配置项
   * {
   *  link : 分享出去的url
   *  title : 标题
   *  desc : 描述
   *  imgUrl : 分享图片地址
   *  disabled : 屏蔽哪些分享途径，可传数组，包括niuyou，chatRoom，nnq，wxFriend，wxTimeline，qq，weibo，facebook，twitter
   * }
   */
  showShare: function showShare(options) {
    if (!browser.isMobileNN()) {
      return;
    }
    var schema = [this.getProtocol('futunn') + '://share/', encodeURIComponent(options.link || window.location.href), '/', encodeURIComponent(options.title || window.document.title), '/',
    //描述和图片不能为空
    encodeURIComponent(options.desc || ' '), '/', encodeURIComponent(options.imgUrl || 'https://www.futunn.com/images/mobile/nn01.png'), '/', filterChannel(options.disabled)];

    // 支持设置成功回调
    if (this.isSupportShareCallback() && (options.success || options.fail)) {
      schema = schema.concat(['/', this._getRandomFn(options.success, options.fail)]);
    }
    _schema["default"].loadSchema(schema.join(''));
  },
  /**
   * 是否支持根据不同的channel定制分享配置
   * @returns {boolean}
   */
  isSupportShareV2: function isSupportShareV2() {
    if (!browser.isMobileNN()) {
      return false;
    }
    if (browser.isMoomoo()) {
      if (this.laterThanAndroid('8.0.229')) {
        return true;
      }
      if (this.laterThanIOS('8.0.223')) {
        return true;
      }
      return false;
    }
    if (this.laterThanAndroid('9.18.1049')) {
      return true;
    }
    if (this.laterThanIOS('9.16.705')) {
      return true;
    }
    return false;
  },
  /**
   * 是否支持口令分享
   * @return {Boolean}
   */
  isSupportPassShare: Utils.isSupportPassShare,
  /**
   * 是否修复了configShareV2协议中客户端只调用一次successfulCallback的bug
   * @param {*} options
   */
  isFixedShareV2: function isFixedShareV2() {
    if (!browser.isMobileNN()) {
      return null;
    }
    if (browser.isMoomoo()) {
      if (this.laterThanAndroid('10.16.1240')) {
        return true;
      }
      if (this.laterThanIOS('10.16.860')) {
        return true;
      }
      return false;
    }
    if (this.laterThanAndroid('10.16.1240')) {
      return true;
    }
    if (this.laterThanIOS('10.16.860')) {
      return true;
    }
    return false;
  },
  /**
   * 格式化分享接口V2的配置
   * @private
   * @param {object} options
   * @return {object}
   */
  formatShareV2Param: function formatShareV2Param(options) {
    // 校验common_model
    var commonModel = options.share_data && options.share_data.common_model;
    if (!commonModel) {
      throw new Error('参数错误：showShareV2接口中`share_data.common_model`必须携带');
    }
    var otherConfig = options.share_data.share_model_list;
    // 如果有share_model_list，校验它
    if (otherConfig) {
      if (!(otherConfig instanceof Array)) {
        throw new Error('参数错误：share_model_list必须是数组类型');
      }
      // 对每一项的channel做格式化
      otherConfig.forEach(function (confItem) {
        var channel = confItem.channel;
        // 如果当前channel项是数字，说明已格式化，不需要格式化了
        if (typeof channel === 'number') {
          return;
        }
        if (!channel) {
          throw new Error('参数错误：share_model_list item中必须有channel key');
        }
        confItem.channel = filterChannel(channel);
      });
    }
    return options;
  },
  /**
   * 兼容分享接口V2的回调处理
   * @private
   * @param {object} options
   * @param {function} successCb
   * @param {function} failCb
   * @return {object}
   */
  formatShareV2Callback: function formatShareV2Callback(options, successCb, failCb) {
    var eitherOfFunction = function eitherOfFunction(a, b) {
      return typeof a === 'function' || typeof b === 'function';
    };
    var optionsBothFn = eitherOfFunction(options.success, options.fail);
    if (optionsBothFn) {
      // 将用户传入data的success和fail生成一个全局的回调函数，再将这个随机函数名放进callback中传给客户端
      options.callback = this._getRandomFn(options.success, options.fail);
    } else if (!optionsBothFn && eitherOfFunction(successCb, failCb)) {
      // 如果业务方没有传入success和fail值，则将successCallback和failCallback整合到callback中 -- 兼容未改变代码的业务方
      options.callback = this._getRandomFn(successCb, failCb);
    }
    if (!this.isFixedShareV2()) {
      // 没有修复configShareV2协议中客户端只调用一次successfulCallback的bug的话：
      // 那么successCallback或者failCallback是一定要传的，不能只传options.success和fail，因为旧版本中只会调用successCallback
      // 只传options.success或者options.fail的话，组件手动帮忙将options.success或者options.fail复制到successCalback和failCallback
      if (optionsBothFn && !eitherOfFunction(successCb, failCb)) {
        successCb = options.success;
        failCb = options.fail;
      }
    }
    return {
      options: options,
      successCb: successCb,
      failCb: failCb
    };
  },
  /**
   * 右上角分享菜单的配置
   * @param {object} options
   * @param {function} successCallback
   * @param {function} failCallback
   */
  configV2: function configV2(options, successCallback, failCallback) {
    options = (0, _toolBase.extend)({}, options, true);
    var isSupportV2 = this.isSupportShareV2();
    if (!browser.isMobileNN()) {
      return;
    }
    var showTitle = options.show_title;
    var commonModel = options.share_data.common_model;
    options = this.formatShareV2Param(options, successCallback, failCallback);

    // @since 1.18.2
    var formats = this.formatShareV2Callback(options, successCallback, failCallback);
    options = formats.options;
    successCallback = formats.successCb;
    failCallback = formats.failCb;
    if (!isSupportV2) {
      // 旧版本不支持V2，走回V1
      this.config({
        link: commonModel.url,
        title: commonModel.title,
        desc: commonModel.description,
        imgUrl: commonModel.image_url,
        disabled: options.disabled,
        showTitle: showTitle,
        linkType: commonModel.link_type,
        success: successCallback,
        fail: failCallback
      });
    } else {
      options.disabled = filterChannel(options.disabled);
      options.enable = filterChannel(options.enable);
      options._findChannelById = this._findChannelById;
      // 新版本走新协议
      _nnq["default"].configV2(options, successCallback, failCallback);
    }
  },
  /**
   * 立即唤起分享
   * @param {object} options
   * @param {function} successCallback
   * @param {function} failCallback
   */
  showShareV2: function showShareV2(options, successCallback, failCallback) {
    options = (0, _toolBase.extend)({}, options, true);
    var isSupportV2 = this.isSupportShareV2();
    if (!browser.isMobileNN()) {
      return;
    }
    var commonModel = options.share_data.common_model;
    options = this.formatShareV2Param(options);

    // @since 1.18.2
    var formats = this.formatShareV2Callback(options, successCallback, failCallback);
    options = formats.options;
    successCallback = formats.successCb;
    failCallback = formats.failCb;
    if (!isSupportV2) {
      // 旧版本不支持V2，走回V1
      this.showShare({
        link: commonModel.url,
        title: commonModel.title,
        desc: commonModel.description,
        imgUrl: commonModel.image_url,
        disabled: options.disabled,
        success: successCallback,
        fail: failCallback
      });
    } else {
      options.disabled = filterChannel(options.disabled);
      options.enable = filterChannel(options.enable);
      options._findChannelById = this._findChannelById;

      // 新版本走新协议
      _nnq["default"].showShareV2(options, successCallback, failCallback);
    }
  },
  /**
   * [closeWebview web请求关闭网页]
   * @return {[type]} [description]
   */
  closeWebview: function closeWebview() {
    if (!browser.isMobileNN()) {
      return;
    }
    var schema = [this.getProtocol('niuniunotice') + '://close_webview'].join('');
    _schema["default"].loadSchema(schema);
  },
  /**
   * 触发牛牛快速分享。
   * @param {Object} options - 配置项
   * {
   *  channel : 分享渠道，包括niuyou，chatRoom，nnq，wxFriend，wxTimeline，qq，weibo，facebook，twitter
   *  link : 分享出去的url
   *  title : 标题
   *  desc : 描述
   *  imgUrl : 分享图片地址
   * }
   */
  quickShare: function quickShare(options) {
    if (!this.isSupportQuickShare()) {
      return;
    }
    var schema = [this.getProtocol('futunn') + '://quickShare/', encodeURIComponent(channelMap[options.channel] || options.channel), '/', encodeURIComponent(options.link || window.location.href), '/', encodeURIComponent(options.title || window.document.title), '/', encodeURIComponent(options.desc || ' '), '/', encodeURIComponent(options.imgUrl || 'https://www.futunn.com/images/mobile/nn01.png')].join('');
    _schema["default"].loadSchema(schema);
  },
  /**
   * 是否支持快速分享scheme
   * @returns {boolean}
   */
  isSupportQuickShare: function isSupportQuickShare() {
    if (!browser.isMobileNN()) {
      return false;
    }
    if (browser.isMoomoo()) {
      return true;
    }
    if (this.laterThanAndroid('5.6.437')) {
      return true;
    }
    if (this.laterThanIOS('6.2.297')) {
      return true;
    }
    return false;
  },
  /**
   * 是否支持webview右上角配置
   * @returns {boolean}
   */
  isSupportSetMenu: function isSupportSetMenu() {
    if (!browser.isMobileNN()) {
      return false;
    }
    if (this.laterThanAndroid('10.18.1260')) {
      return true;
    }
    if (this.laterThanIOS('10.18.880')) {
      return true;
    }
    return false;
  },
  /**
   * [loginWithUid web请求立即登录,并将uid填入登录框]
   * @param  {String|Number} uid [牛牛号]
   * @return {[type]}     [description]
   */
  loginWithUid: function loginWithUid(uid) {
    if (!browser.isMobileNN() || !uid) {
      return false;
    }
    var schema = this.getProtocol('niuniunotice') + '://login_now?uid=' + uid;
    _schema["default"].loadSchema(schema);
  },
  /**
   * [login 触发牛牛登录入口]
   * 当前暂无参数
   */
  login: function login() {
    if (!this.isSupportLogin()) {
      return false;
    }
    var schema = [this.getProtocol('futunn') + '://login'].join('');
    _schema["default"].loadSchema(schema);
  },
  /**
   * [callIM 调起客户端客户服务]
   * @return {[type]} [description]
   */
  callHelper: function callHelper() {
    return this.chatWith(customerService);
  },
  /**
   * [tel 调起打电话功能,牛牛内外均可使用]
   * @param  {String} phonenumber [电话号码]
   * @return {undefined}
   */
  tel: function tel(phonenumber) {
    if (!phonenumber) {
      return;
    }
    var schema = 'tel:' + phonenumber;

    // NN 中使用牛牛协议
    if (this.laterThanAndroid('7.11.572') || this.laterThanIOS('7.14.420')) {
      schema = this.getProtocol('futunn') + '://tel/' + phonenumber;
    }
    // 注意，使用这种方式兼容性最佳
    _schema["default"].loadSchema(schema);
  },
  /**
   * [openUrl 打开某个url，牛牛内外都可适用,在牛牛中时，在新窗口中打开，牛牛外部时直接跳转]
   * @param  {String} url [url地址]
   */
  openUrl: function openUrl(url) {
    if (!url) {
      return;
    }
    if (browser.isMobileNN()) {
      _schema["default"].loadSchema(this.getProtocol('futunn') + '://url/' + encodeURIComponent(url));
    } else {
      window.location.href = url;
    }
  },
  /**
   * [chatWith 和指定的nn号聊天,如果未添加好友则提示添加]
   * @param  {[type]} nnNumber [description]
   * @return {[type]}          [description]
   */
  chatWith: function chatWith(nnNumber) {
    if (!browser.isMobileNN() || !/\d+/g.test(nnNumber)) {
      return false;
    }
    var schema = [this.getProtocol('futunn') + '://chat', '/', nnNumber].join('');
    _schema["default"].loadSchema(schema);
  },
  /**
   * [isSupportLogin 是否支持登陆]
   * @return {Boolean}
   */
  isSupportLogin: function isSupportLogin() {
    if (!browser.isMobileNN()) {
      return false;
    }
    if (browser.isMoomoo()) {
      return true;
    }
    if (this.laterThanAndroid('6.0.460')) {
      return true;
    }
    if (this.laterThanIOS('6.5.309')) {
      return true;
    }
    return false;
  },
  /**
   * 是否支持跳转到个股页面scheme
   * @returns {boolean}
   */
  isSupportStockScheme: function isSupportStockScheme() {
    if (!browser.isNnPlatform()) {
      return false;
    }
    if (browser.isMoomoo()) {
      return true;
    }
    if (browser.isMobileNN() || browser.isPCNN()) {
      return true;
    }
    if (this.laterThanMac('3.8.7')) {
      return true;
    }
    return false;
  },
  /**
   * 唤起第三方登录的scheme，登录成功后牛牛客户端会将相关数据回传给回调函数fnName
   * @param type 目前支持weixin,weibo,qq,facebook,twitter，xiaomi，google
   * @param fnName 回调函数名，定义到window下面
   */
  thirdPartyAuthorization: function thirdPartyAuthorization(type, fnName) {
    if (!this.isSupportThridPartyAuthorization()) {
      return;
    }
    _schema["default"].loadSchema(this.getProtocol('niuniunotice') + '://' + type + '_authorization?callback=' + fnName);
  },
  /**
   * [isSupportThridPartyAuthorization 是否支持第三方登陆]
   * @return {Boolean} [description]
   */
  isSupportThridPartyAuthorization: function isSupportThridPartyAuthorization() {
    if (!browser.isMobileNN()) {
      return false;
    }
    if (browser.isMoomoo()) {
      return true;
    }
    if (this.laterThanAndroid('6.1.0')) {
      return true;
    }
    if (this.laterThanIOS('6.5.309')) {
      return true;
    }
    return false;
  },
  /**
   * [getNNType 获取牛牛客户端类型]
   * @return {[type]} [description]
   */
  getNNType: function getNNType() {
    if (!browser.isNnPlatform()) {
      return '';
    }
    if (browser.isMacNN()) {
      return 'Mac';
    } else if (browser.isDesktopNN()) {
      return 'PC';
    } else if (browser.isMobileNN()) {
      if (browser.isAndroid()) {
        return 'Android';
      } else {
        return 'IOS';
      }
    }
  },
  /**
   * [getNNversion 获取NN 版本号]
   * @return {[type]} [description]
   */
  getNNversion: function getNNversion() {
    if (!browser.isNnPlatform()) {
      return {
        type: '',
        version: ''
      };
    }
    var nnType = this.getNNType();
    var v = (0, _toolBrowser.getNNVersion)();
    return {
      type: nnType,
      version: v
    };
  },
  /**
   * [laterThanIOS ios客户端版本是否大于等于某个版本]
   * @param  {[type]} v [description]
   * @return {[type]}   [description]
   */
  laterThanIOS: Utils.laterThanIOS,
  /**
   * [laterThanAndroid Android客户端版本是否大于等于某个版本]
   * @param  {[type]} v [description]
   * @return {[type]}   [description]
   */
  laterThanAndroid: Utils.laterThanAndroid,
  /**
   * [laterThanMac Mac客户端版本是否大于等于某个版本]
   * @param  {[type]} v [description]
   * @return {[type]}   [description]
   */
  laterThanMac: Utils.laterThanMac,
  /**
   * [laterThanPC PC客户端版本是否大于等于某个版本]
   * @param  {[type]} v [description]
   * @return {[type]}   [description]
   */
  laterThanPC: Utils.laterThanPC,
  /**
   * [beforeThanIOS ios客户端版本是否小于某个版本]
   * @param  {[type]} v [description]
   * @return {[type]}   [description]
   */
  beforeThanIOS: Utils.beforeThanIOS,
  /**
   * [beforeThanAndroid Android客户端版本是否小于某个版本]
   * @param  {[type]} v [description]
   * @return {[type]}   [description]
   */
  beforeThanAndroid: Utils.beforeThanAndroid,
  /**
   * [beforeThanMac Mac客户端版本是否小于某个版本]
   * @param  {[type]} v [description]
   * @return {[type]}   [description]
   */
  beforeThanMac: Utils.beforeThanMac,
  /**
   * [beforeThanPC PC客户端版本是否大于等于某个版本]
   * @param  {[type]} v [description]
   * @return {[type]}   [description]
   */
  beforeThanPC: Utils.beforeThanPC,
  /**
   * [isSupportControllBackAction 客户端是否支持控制返回按钮或者事件]
   * @return {Boolean} [description]
   */
  isSupportControllBackAction: function isSupportControllBackAction() {
    if (!browser.isMobileNN()) {
      return false;
    }
    if (browser.isMoomoo()) {
      return true;
    }
    if (this.laterThanAndroid('7.3.534')) {
      return true;
    }
    if (this.laterThanIOS('7.4.367')) {
      return true;
    }
    return false;
  },
  /**
   * [DisableBackAction web请求禁用用户返回操作,ios版本从7.4.367，android从7.3.534版本开始支持，
   * 禁用后用户不能通过关闭或者返回按键关闭当前web页面]
   */
  disableBackAction: function disableBackAction() {
    if (!this.isSupportControllBackAction()) {
      return;
    }
    _schema["default"].loadSchema(this.getProtocol('niuniunotice') + '://disable_user_back_action');
  },
  /**
   * [enablBackAction web请求起用用户返回操作,ios版本从7.4.367，android从7.3.534版本开始支持，
   * 启用后用户可以通过关闭或者返回按键关闭当前web页面]
   * @return {[type]} [description]
   */
  enableBackAction: function enableBackAction() {
    if (!this.isSupportControllBackAction()) {
      return;
    }
    _schema["default"].loadSchema(this.getProtocol('niuniunotice') + '://enable_user_back_action');
  },
  /**
   * [isSupportControllBackAction 客户端是否支持控制返回按钮或者事件]
   * @return {Boolean} [description]
   */
  isSupportSnapshot: function isSupportSnapshot() {
    if (!browser.isMobileNN()) {
      return false;
    }
    if (browser.isMoomoo()) {
      return true;
    }
    if (this.laterThanAndroid('7.9.564')) {
      return true;
    }
    if (this.laterThanIOS('7.12.407')) {
      return true;
    }
    return false;
  },
  /**
   * [shareSnapshot 微信好友、朋友圈分享快照]
   * @param  {Object} option [微信朋友圈分享快照配置]
   * @param  {String} option.type [图片的资源类型，可取值为url，base64]
   * @param  {Object} option.data [当type为url是，data表示图片地址，当type为base64时，data表示base64数据]
   * @return {[type]}        [description]
   */
  configSnapshot: function configSnapshot(option) {
    if (!this.isSupportSnapshot()) {
      return false;
    }
    var schemaUrl = this.getProtocol('niuniunotice') + '://snapshot_share?';

    // 支持设置成功回调
    if (this.isSupportShareCallback() && (option.success || option.fail)) {
      schemaUrl = schemaUrl + 'callback=' + this._getRandomFn(option.success, option.fail) + '&';
    }

    // 分享的是图片链接
    if (option.type.toLowerCase() === 'url') {
      schemaUrl += 'datatype=url&data=' + encodeURIComponent(option.data);

      // 分享的是base64数据
    } else if (option.type.toLowerCase() === 'base64') {
      // 读取base64中的格式
      var extMatch = /^data:image\/(\w+);base64,/gi.exec(option.data);
      var imagetype = Array.isArray(extMatch) && extMatch[1] ? extMatch[1] : 'png';

      // 发送给后端的不包括格式头部分
      option.data = option.data.replace(/^data:image\/(?:\w+);base64,/gi, '');
      schemaUrl += 'datatype=base64&imagetype=' + imagetype + '&data=' + encodeURIComponent(option.data);
    } else {
      throw new Error('the type shoule be "url" or "base64"');
    }
    _schema["default"].loadSchema(schemaUrl);
  },
  /**
   * [configSnapshotByAPI 请求某个api，获取分享快照的图片地址，做分享快照]
   * @param  {Object} option    [配置项]
   * @param  {String} option.apiurl      [需要获取图片地址的api接口地址]
   * @param  {function} [option.success] [配置成功的回调函数，此回调不能判断是否成功分享给好友]
   * @param  {function} [option.error]   [请求图片地址失败]
   * @param  {function} [option.parseUrl] [函数，参数为接口返回值，使用者可自定义图片地址，此时要求函数返回字符串，以此作为分享的图片链接]
   * @return {undefined}
   */
  configSnapshotByAPI: function configSnapshotByAPI(option) {
    if (!this.isSupportSnapshot()) {
      option.error && option.error({
        message: '当前客户端版本不支持快照分享'
      });
      return false;
    }
    var that = this;
    (0, _toolXhr.get)({
      url: option.apiurl
    }, {
      codeName: 'code',
      msgName: 'message',
      defaultErrorMsg: '分享快照失败，请稍后再试',
      dataName: ''
    }).then(function (ret) {
      var imgUrl = null;

      // 允许用户自定义url
      if (typeof option.parseUrl === 'function') {
        var parseResult = option.parseUrl(ret);
        if (typeof parseResult === 'string' && parseResult.length > 0) {
          imgUrl = parseResult;
        }
      }

      // 默认取返回值值的data.url 属性
      if (!imgUrl && ret.data && ret.data.url) {
        imgUrl = ret.data.url;
      }

      // 图片url获取失败，返回
      if (!imgUrl) {
        typeof option.error === 'function' && option.error({
          message: '获取图片url失败'
        });
        return;
      }
      that.configSnapshot({
        type: 'url',
        data: imgUrl
      });
      typeof option.success === 'function' && option.success(ret);
    }, option.error);
  },
  /**
   * [showSnapshotShare 显示分享快照的吸底TAB，注意需要与configSnapshot有一定的时间间隔]
   * @param  {Object} option [分享快照配置,可为null]
   * @param  {JSON}  [option.disabled] [对各个快照渠道的开关控制{wxFriend：true，wxTimeline：true}]
   * @return {undefined}
   */
  showSnapshotShare: function showSnapshotShare(option) {
    if (!this.isSupportSnapshot()) {
      return;
    }
    var schema = [this.getProtocol('futunn') + '://share_snapshot/', filterSnapshotChannel(option)].join('');
    _schema["default"].loadSchema(schema);
  },
  /**
   * [isSupportControllSwiper 是否支持控制app的左右滑动的开启与禁用]
   * @return {Boolean} [description]
   */
  isSupportControllSwiper: function isSupportControllSwiper() {
    if (!browser.isMobileNN()) {
      return false;
    }

    // moomoo不支持
    if (browser.isMoomoo()) {
      return false;
    }
    if (this.laterThanAndroid('8.19.760')) {
      return true;
    }
    if (this.laterThanIOS('8.42.571')) {
      return true;
    }
    return false;
  },
  /**
   * [enableSwiper 开启APP的左右滑动功能,切换app的左右滑动功能是否启用，app内默认是启用，如果与页面上的左右滑动功能冲突，需要做app的滑动禁用]
   * @return {[type]} [description]
   */
  enableSwiper: function enableSwiper() {
    if (!this.isSupportControllSwiper()) {
      return;
    }
    _schema["default"].loadSchema('niuniunotice://enable_user_pop_gesture');
  },
  /**
   * [disableSwiper 禁用APP的左右滑动功能]
   * @return {[type]} [description]
   */
  disableSwiper: function disableSwiper() {
    if (!this.isSupportControllSwiper()) {
      return;
    }
    _schema["default"].loadSchema('niuniunotice://disable_user_pop_gesture');
  },
  /**
   * [getMoomooSetupSchema 根据版本号获取到合适的开户schema]
   * @return {String} [开户schema]
   */
  getMoomooSetupSchema: function getMoomooSetupSchema() {
    if (!browser.isMoomoo()) {
      return '';
    }

    // 新版开户schema
    if (this.laterThanAndroid('1.4.120') || this.laterThanIOS('1.4.120')) {
      return 'futumm://openaccount/guide';
    } else {
      return 'futumm://subaccount/detail/us';
    }
  },
  /**
   *
   * [moomooSetup 进入moomoo的原生开户界面]
   * @return {void}
   */
  moomooSetup: function moomooSetup() {
    if (!browser.isMoomoo()) {
      return;
    }
    var setupSchema = this.getMoomooSetupSchema();
    setupSchema && _schema["default"].loadSchema(setupSchema);
  },
  /**
   * [isSupportShareCallback 是否支持分享回调]
   * @return {Boolean} [description]
   */
  isSupportShareCallback: function isSupportShareCallback() {
    if (!browser.isMobileNN()) {
      return false;
    }
    if (this.laterThanAndroid('9.1.901')) {
      return true;
    }
    if (this.laterThanIOS('9.1.591')) {
      return true;
    }
    return false;
  },
  /**
   * [isSupportBuyCard 是否支持购买行情卡]
   * @return {Boolean} [description]
   */
  isSupportBuyCard: function isSupportBuyCard() {
    if (!browser.isMobileNN()) {
      return false;
    }

    // moomoo不支持
    if (browser.isMoomoo()) {
      return false;
    }
    if (this.laterThanAndroid('9.5.941')) {
      return true;
    }
    if (this.laterThanIOS('9.8.633')) {
      return true;
    }

    // ios不支持
    return false;
  },
  /**
   * [buyCard 行情卡购买]
   * @param  {Number} cardtype [行情卡类型,
   港股LV2行情          1
      A股LV2              2
      NASDAQ TotalView    3
      NYSE OpenBook       4
      全美最佳行情LV1       5
      ]
      * @return {void}
      */
  buyCard: function buyCard(cardtype) {
    if (!this.isSupportBuyCard()) {
      return;
    }
    if (+cardtype >= 1 && +cardtype <= 5) {
      _schema["default"].loadSchema('futunn://store/quotecard/' + cardtype);
    }
  },
  /**
   * [_getRandomFnName 获取一个随机的函数名称，用于挂载在windows下]
   * @privite
   * @return {String} [fn name]
   */
  _getRandomFn: function _getRandomFn(successFn, failFn) {
    var fnName = '_toolnn_callback_' + (~~(Math.random() * 10000) + '' + (new Date().getTime() + '').substr(-6));
    var that = this;
    window[fnName] = function (res) {
      if (typeof res === 'string') {
        try {
          res = JSON.parse(res);
        } catch (e) {
          res = {};
          console.warn(e);
        }
      }
      var channel = that._findChannelById(res.channel);
      if (+res.result === 0) {
        typeof successFn === 'function' && successFn(channel);
      } else {
        typeof failFn === 'function' && failFn(channel);
      }
    };
    return fnName;
  },
  /**
   * 根据channelid 返回channel名称
   * @privite
   * @returns {String} [channel]
   */
  _findChannelById: Utils.findChannelById,
  /**
   * [isSupportAddressBook 是否支持通讯录协议]
   * @returns {boolean}
   */
  isSupportPhoneContact: function isSupportPhoneContact() {
    if (!browser.isMobileNN()) {
      return false;
    }
    // 目前不支持moomoo
    if (browser.isMoomoo()) {
      return false;
    }
    if (this.laterThanAndroid('9.10.975')) {
      return true;
    }
    if (this.laterThanIOS('9.9.639')) {
      return true;
    }
    return false;
  },
  /**
   * 通讯录是否已经授权
   * @param option 已授权时执行option.success；未授权时执行option.fail
   */
  contactsIsAuth: function contactsIsAuth(option) {
    if (!this.isSupportPhoneContact()) {
      return;
    }
    if (option == null) {
      option = {};
    }
    _schema["default"].loadSchema(this.getProtocol('futunn') + '://' + 'contacts/get_status?callback=' + this._getRandomFn(option.success, option.fail));
  },
  /**
   * 请求通讯录授权
   * @param option 客户端获得授权并且上传通讯录成功时执行option.success；通讯录授权失败时（申请失败、上传失败或者联系人为空）执行option.fail
   */
  requestContactsAuth: function requestContactsAuth(option) {
    if (!this.isSupportPhoneContact()) {
      return;
    }
    if (option == null) {
      option = {};
    }
    _schema["default"].loadSchema(this.getProtocol('futunn') + '://' + 'contacts/authorize?callback=' + this._getRandomFn(option.success, option.fail));
  },
  /**
   * 同步通讯录
   * @param option 上传通讯录成功，或者无新增联系人时执行option.success；上传失败或者联系人为空时执行option.fail
   */
  syncContacts: function syncContacts(option) {
    if (!this.isSupportPhoneContact()) {
      return;
    }
    if (option == null) {
      option = {};
    }
    _schema["default"].loadSchema(this.getProtocol('futunn') + '://' + 'contacts/sync?callback=' + this._getRandomFn(option.success, option.fail));
  },
  /**
   * [isSupportCloseWithBankCard 是否支持closeWithBankCard]
   * @returns {boolean}
   */
  isSupportCloseWithBankCard: function isSupportCloseWithBankCard() {
    if (!browser.isMobileNN()) {
      return false;
    }
    if (this.laterThanAndroid('10.14.1219')) {
      return true;
    }
    if (this.laterThanIOS('10.14.839')) {
      return true;
    }
    return false;
  },
  /**
   * [closeWithBankCard]
   * @param {object} options
   * @param {} options.bankCardId 银行卡号
   */
  closeWithBankCard: function closeWithBankCard(options) {
    if (!this.isSupportCloseWithBankCard()) {
      return;
    }
    var schema = [this.getProtocol('niuniunotice') + '://close_with_bank_card?bankCardId=', encodeURIComponent(options.bankCardId || 0)];
    _schema["default"].loadSchema(schema.join(''));
  },
  /**
   * 获取Android客户端的下载渠道
   * @return {Number} 渠道类型 
   */
  getAndroidClientChannelType: function getAndroidClientChannelType() {
    if (!browser.isMobileNN()) {
      return -2;
    }
    if (!browser.isAndroid()) {
      return -3;
    }
    var userAgent = window.navigator.userAgent;
    var reg = /ClientChannelType\/(\d+)/gi;
    var matches = reg.exec(userAgent);
    if (matches && matches.length > 1) {
      return Number(matches[1]);
    }
    return -1;
  }
};
module.exports = exports.default;